// src/components/AccountCancelled.tsx
// Page shown after user confirms account cancellation via email link

import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from './PageHeader.tsx';

export const AccountCancelled: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <PageHeader
        icon="⚠️"
        title="Account Cancellation Confirmed"
        description="Your account has been scheduled for deletion"
      />

      <div style={{
        marginTop: '30px',
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        border: '3px solid #ff9800'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '64px', marginBottom: '20px' }}>⏳</div>
          
          <h2 style={{ color: '#e65100', marginBottom: '20px' }}>
            7-Day Grace Period Active
          </h2>

          <p style={{ fontSize: '16px', color: '#666', marginBottom: '30px', lineHeight: '1.6' }}>
            Your account has been locked and is scheduled for permanent deletion in 7 days.
            <br />
            During this time, you will not be able to play games or access most features.
          </p>

          <div style={{
            backgroundColor: '#fff3e0',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '30px'
          }}>
            <h3 style={{ color: '#e65100', margin: '0 0 15px 0' }}>
              Changed your mind?
            </h3>
            <p style={{ color: '#666', margin: '0 0 15px 0' }}>
              You can reactivate your account at any time during the 7-day grace period.
              Simply log in and go to your Profile → Account Settings → Reactivate Account.
            </p>
          </div>

          <div style={{
            backgroundColor: '#ffebee',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '30px'
          }}>
            <h3 style={{ color: '#c62828', margin: '0 0 15px 0' }}>
              What will be deleted?
            </h3>
            <ul style={{ 
              textAlign: 'left', 
              color: '#666', 
              margin: 0, 
              paddingLeft: '20px',
              lineHeight: '1.8'
            }}>
              <li>Your profile and account information</li>
              <li>All game history and statistics</li>
              <li>Custom variants you created</li>
              <li>Color schemes and preferences</li>
              <li>Leaderboard rankings</li>
            </ul>
          </div>

          <p style={{ fontSize: '14px', color: '#999', marginBottom: '30px' }}>
            A confirmation email has been sent to your registered email address.
            <br />
            You will receive a final reminder 24 hours before deletion.
          </p>

          <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
            <button
              onClick={() => navigate('/login')}
              style={{
                padding: '12px 30px',
                backgroundColor: '#4caf50',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
            >
              Log In to Reactivate
            </button>
            <button
              onClick={() => navigate('/')}
              style={{
                padding: '12px 30px',
                backgroundColor: '#e0e0e0',
                color: '#333',
                border: 'none',
                borderRadius: '6px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
            >
              Return Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountCancelled;
